import * as yup from "yup";

export const ChainsAndStatesValidationSchema = 
yup.object().shape({
    states: yup
        .array()
        .required()
        .of(
            yup
            .string()
            .required("É necessário selecionar ao menos um estado para continuar.")
        )
        .min(1, "É necessário selecionar ao menos um estado para continuar."),
    headquarters: yup
        .array()
        .required()
        .of(
            yup
            .string()
            .required("É necessário selecionar ao menos uma rede para continuar.")
        )
        .min(1, "É necessário selecionar ao menos uma rede para continuar."),
});